import { uri } from 'modapp-utils';
import * as base64 from 'utils/base64';
import './errorScreen.scss';
import errorToLocaleString from 'utils/errorToLocaleString';
import l10n from 'utils/l10n';

/**
 * ErrorScreen shows login error messages, otherwise calls auth.authenticate.
 */
class ErrorScreen {

	constructor(app, params) {
		this.app = app;

		this.app.require([
			'auth',
		], this._init.bind(this));
	}

	_init(module) {
		this.module = module;

		let q = uri.getQuery();
		if (q.error) {
			try {
				let err = JSON.parse(base64.decodeUtf8(q.error));
				this._showError(err);
			} catch (e) {
				console.error("Failed to parse error message: ", e);
				console.error(`Message: "${q.error}"`);
				this._redirect();
			}
		} else if (q.done) {
			try {
				let done = JSON.parse(base64.decodeUtf8(q.done));
				this._showDone(done);
			} catch (e) {
				console.error("Failed to parse done message: ", e);
				console.error(`Message: "${q.error}"`);
				this._redirect();
			}
		} else if (q.confirm) {
			try {
				let confirm = JSON.parse(base64.decodeUtf8(q.confirm));
				this._showConfirm(confirm);
			} catch (e) {
				console.error("Failed to parse confirm message: ", e);
				console.error(`Message: "${q.error}"`);
				this._redirect();
			}
		} else {
			this._showLoader();
			this.module.auth.authenticate().catch(err => {
				if (err.code == 'system.connectionError') {
					err = { code: err.code, message: "Det gick inte att ansluta till Nercia API. Kontakta Nercia om felet kvarstår." };
				}
				console.error("Authentication failed: ", err);
				this._showError(err);
			});
		}
	}

	_showError(err) {
		this.app.setComponent(new class {
			render(el) {
				const e = document.createElement('div');
				e.classList.add('errorscreen');
				e.innerHTML = '<div class="errorscreen--cont">' +
					'<div class="errorscreen--wrapper">' +
						'<h3 class="errorscreen--title">Något gick fel</h3>' +
						'<div class="errorscreen--content">' +
							'<p>Ett fel inträffade när du försökte logga in:</p>' +
							'<i id="msg"></i>' +
						'</div><div class="errorscreen--footer">' +
							'<a class="errorscreen--link" id="link">Gå tillbaka</a>' +
						'</div>' +
					'</div>' +
				'</div>';
				e.querySelector("#msg").textContent = l10n.t(errorToLocaleString(err));
				let url = window.location.href.split('?')[0];
				let l = e.querySelector("#link");
				l.href = url;
				if (url == window.location.href) {
					l.onclick = () => window.location.reload();
				}

				this.div = e;
				el.appendChild(e);
				return e;
			}
			unrender() {
				this.div?.remove();
			}
		});
	}

	_showLoader() {
		this.app.setComponent(new class {
			render(el) {
				const spinner = document.createElement("div");
				spinner.className = 'errorscreen';
				spinner.innerHTML = '<div class="errorscreen--loader"><div class="spinner"></div></div>';
				el.appendChild(spinner);
				this.spinner = spinner;
			}
			unrender() {
				this.spinner?.remove();
			}
		});
	}

	_showDone(done) {
		const { title, body } = done;
		this.app.setComponent(new class {
			render(el) {
				const e = document.createElement('div');
				e.classList.add('errorscreen');
				e.innerHTML = '<div class="errorscreen--cont">' +
					'<div class="errorscreen--wrapper">' +
						'<h3 class="errorscreen--title" id="title"></h3>' +
						'<div class="errorscreen--content">' +
							'<p id="body" class="errorscreen--body"></p>' +
						'</div><div class="errorscreen--footer">' +
							'<a class="errorscreen--link" id="link">Till inlogg</a>' +
						'</div>' +
					'</div>' +
				'</div>';
				e.querySelector("#title").textContent = title;
				e.querySelector("#body").textContent = body;
				let url = window.location.href.split('?')[0];
				let l = e.querySelector("#link");
				l.href = url;
				if (url == window.location.href) {
					l.onclick = () => window.location.reload();
				}
				this.div = e;
				el.appendChild(e);
				return e;
			}
			unrender() {
				this.div?.remove();
			}
		});
	}

	_showConfirm(confirmObj) {
		const { title, body, confirm, token } = confirmObj;
		const url = this.module.auth.getActionUrl(token, confirm);
		this.app.setComponent(new class {
			render(el) {
				const e = document.createElement('div');
				e.classList.add('errorscreen');
				e.innerHTML = '<div class="errorscreen--cont">' +
					'<div class="errorscreen--wrapper">' +
						'<h3 class="errorscreen--title" id="title"></h3>' +
						'<div class="errorscreen--content">' +
							'<p id="body" class="errorscreen--body"></p>' +
						'</div><div class="errorscreen--footer">' +
							'<a class="errorscreen--link" id="link"></a>' +
						'</div>' +
					'</div>' +
				'</div>';
				e.querySelector("#title").textContent = title;
				e.querySelector("#body").textContent = body;
				let l = e.querySelector("#link");
				l.textContent = confirm || "Okej";
				l.href = url;
				this.div = e;
				el.appendChild(e);
				return e;
			}
			unrender() {
				this.div?.remove();
			}
		});
	}

	_redirect() {
		window.location.replace(window.location.href.split('?')[0]);
	}
}

export default ErrorScreen;
